import * as React from "react";
import { Router, Switch, Route, Redirect } from "react-router";

import moment from "moment";

import { history } from "./stores";
import GameDashStartPage from "./pages/gameStart";
import GameResultPage from "./pages/gameResult";

// question and mtr point
export default function Routers() {
  return (
    <Router history={history}>
      <Switch>
        <Route path={"/"} exact component={GameDashStartPage} />
        <Route path={"/game/result"} exact component={GameResultPage} />

        <Route path="*">
          <Redirect from={"/"} to={"/"} />
        </Route>
      </Switch>
    </Router>
  );
}
